import Vue from 'vue';
import mixin from './mixin.js';

require(`./assets/${process.env.VUE_APP_BRAND}/scss/_fonts.scss`);

window.startupTSVue = new Date().getTime();
if (window.initialData.logins) {
	// JSON.parse required because BE can't print \n they only can do \\n if we want predefined line-breaks HOMEPAGE-3689
	window.initialData.logins = JSON.parse(JSON.stringify(window.initialData.logins).replace('\\\\n', '\\n'));
}

Vue.prototype.$initialData = window.initialData;

new Vue({
	el: '#app',
	mixins: [mixin],
	components: {
		'hp-app': require('./App.vue').default
	}
});
